<template>
  <div
    class="consult-classify-selects"
    :style="{ 'max-height': `calc((100vh - ${top}px) * .75)` }"
  >
    <div class="consult-classify-selects-list-content">
      <p v-if="title" class="title">{{ title }}</p>
      <dateSelects
        v-if="dates && type === 'filter'"
        ref="dateSelectRef"
        :value="value"
        title="咨询时间（北京时间，可多选）"
        :list="dates"
        :showBtns="false"
        @change="submit"
      />
      <selects
        v-for="(item, index) in list"
        :key="index"
        :list="item.list"
        :title="item.title"
        :size="212"
        :value="selected"
        :statPrefix="item.title"
        @change="change"
        @multipleChange="multipleChange"
      />
    </div>
    <div class="btns">
      <!-- <div class="btn-list">
        <div class="btn" @click="reset" v-stat="'筛选重置按钮'">重置</div>
        <div class="btn" @click="submit" v-stat="'筛选确定按钮'">确定</div>
      </div> -->

      <buttons
        :btns="[
          { label: '重置', onClick: reset, stat: '筛选重置按钮' },
          { label: '确定', onClick: beforeSubmit, stat: '筛选确定按钮' }
        ]"
      />
    </div>
  </div>
</template>

<script>
import selects from 'app/web/component/consult/listCommon/selects.vue'
import buttons from 'app/web/component/consult/listCommon/buttons.vue'
import dateSelects from 'app/web/component/consult/listCommon/dateSelects.vue'
export default {
  components: { selects, buttons, dateSelects },
  props: {
    value: {
      type: Object
    },
    list: {
      type: Array
    },
    top: {
      type: Number
    },
    type: {
      type: String
    },
    dates: {
      type: Object
    },
    title: {
      type: String
    }
  },
  data() {
    return {
      selected: {}
    }
  },
  mounted() {
    const allSelects = this.list.reduce((all, v) => [...all, v], [])
    for (let i = 0; i < allSelects.length; i++) {
      const type = allSelects[i].type
      this.$set(this.selected, type, this.value[type] || '')
    }
  },
  methods: {
    multipleChange(v) {
      // 多选
      for (let key in v) {
        let selected = this.selected[key] ? this.selected[key].split(',') : []
        const isSelected = selected && selected.indexOf(v[key]) > -1

        console.log(isSelected, selected)

        if (isSelected) {
          selected = selected.filter(item => item !== v[key])
        } else {
          selected.push(v[key])
        }

        selected = selected.join(',')

        this.$set(this.selected, key, selected)
      }
    },
    change(v) {
      // 单选
      for (let key in v) {
        if (this.selected[key] === v[key]) {
          this.$set(this.selected, key, undefined)
        } else {
          this.$set(this.selected, key, v[key])
        }
      }
    },
    // 有日期 提交之前先处理日期
    beforeSubmit() {
      if (this.dates && this.type === 'filter')
        return this.$refs.dateSelectRef.submit()
      this.submit({})
    },
    submit(v) {
      this.$emit('change', { ...v, ...this.selected })
    },
    reset() {
      for (let key in this.selected) {
        this.selected[key] = ''
      }
      // 有日期 需要重置
      if (this.dates && this.type === 'filter') this.$refs.dateSelectRef.reset()
      // this.$emit('change', this.selected)
    }
  },
  computed: {
    isFullScreen() {
      return this.canHideNavigationBar
    }
  }
}
</script>

<style lang="scss">
.consult-classify-selects {
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;

  &-list-content {
    // flex: 1;
    overflow-y: auto;
  }
  .btns {
    // padding-bottom: constant(safe-area-inset-bottom);
    // padding-bottom: env(safe-area-inset-bottom);
    // .btn-list {
    //   height: 108px !important;
    //   width: 100%;
    //   display: flex;
    //   box-sizing: border-box;
    //   justify-content: space-between;
    //   align-items: center;
    //   padding: 0 30px;

    //   padding-bottom: constant(safe-area-inset-bottom);
    //   padding-bottom: env(safe-area-inset-bottom);
    //   .btn {
    //     width: 210px;
    //     height: 80px;
    //     border-radius: 100px;
    //     color: #fff;
    //     background-color: #bcc2cf;
    //     line-height: 80px;
    //     text-align: center;
    //     font-size: 30px;
    //     &:nth-of-type(2) {
    //       flex: 1;
    //       width: 360px;
    //       margin-left: 20px;
    //       background-color: #ffa202;
    //     }
    //   }
    // }
  }
}
</style>
<style lang="scss" scoped>
.title {
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 700;
  color: #21252d;
  line-height: 28px;
  text-align: left;
  padding: 30px 0 10px 32px;
}
</style>
